import UnCertifiedIcon from "@/assets/icons/sidebar/unCertified";
import { redirectToAuth } from "@/pages/profile/helper/redirectToAuth";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "@/store/GlobalStore";
import styled from "styled-components";

export function InvoiceHeaderExtra() {
  const { t } = useTranslation("error");
  const { isCertified, userInfo, isDomestic } = useGlobalStore();

  if (isCertified || !isDomestic) return null;

  return (
    <ContentUnCertifiedWarn>
      <UnCertifiedIcon />
      {t("user_auth_certified_invoice_warning_1")}
      <AuthLink onClick={() => redirectToAuth(userInfo)}>
        {t("user_auth_certified_invoice_warning_2")}
      </AuthLink>
    </ContentUnCertifiedWarn>
  );
}

const ContentUnCertifiedWarn = styled.div`
  width: auto;
  line-height: 36px;
  padding: 0 25px 0 15px;
  margin: 0 0 0 20px;
  border-radius: 4px;
  background: #482e2d;
  color: #e25c59;
  font-size: 14px;
  display: inline-flex;
  svg {
    width: 20px;
    margin-right: 12px;
  }
`;

const AuthLink = styled.div`
  color: #83bfed;
  cursor: pointer;
`;
